import React, { useCallback, useEffect, useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// Components
import Login from '../login/login';
import ForgotPassword from '../forgot-password/forgot-password';
import ChangePassword from '../change-password/change-password';
import StorageService from '../../services/storage-service';
import DashboardPanel from '../dashboard-panel/dashboard-panel';
import Modal from '../modal/modal';
import Toast from '../toast/toast';
import useReloadOnNewBuild from '../../hooks/use-reload-on-new-build';

// Providers
import {
  GeneralContext,
  initialModalContent,
  initialToastContent,
} from '../../providers/general-provider';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
// TODO: Remove ResolutionIndicator when tablet development is complete
import ResolutionIndicator from '../resolution-indicator/resolution-indicator';

function App() {
  const [modalContent, setModalContent] = useState(initialModalContent);
  const [toastContent, setToastContent] = useState(initialToastContent);

  const anonymousRoutes = ['/esqueci-minha-senha', '/alterar-senha', '/login'];
  const navigate = useNavigate();
  const location = useLocation();
  const storageService = new StorageService();

  const [isAuthenticated, setAuthenticated] = useState(false);

  useReloadOnNewBuild();

  const redirectToLogin = useCallback(() => {
    if (location.pathname !== '/login') {
      navigate('/login');
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    const auth = storageService.getAuthInfo();

    if (auth) {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);

      if (!anonymousRoutes.includes(location.pathname)) {
        redirectToLogin();
      }
    }
  }, [storageService, anonymousRoutes, location.pathname, redirectToLogin]);

  return (
    <GeneralContext.Provider
      value={{
        setModalContent: setModalContent,
        setToastContent: setToastContent,
      }}
    >
      <DndProvider backend={HTML5Backend}>
        {/* TODO: Remove ResolutionIndicator when tablet development is complete */}
        {/* <ResolutionIndicator /> */}
        <Modal content={modalContent} />
        <Toast content={toastContent} />
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/esqueci-minha-senha' element={<ForgotPassword />} />
          <Route path='/alterar-senha' element={<ChangePassword />} />
          <Route path='/*' element={isAuthenticated ? <DashboardPanel /> : null} />
        </Routes>
      </DndProvider>
    </GeneralContext.Provider>
  );
}

export default App;
